module.exports = __webpack_public_path__ + "assets/img/WalletConnect.29a6a4a6.png";